import * as types from 'store/types';
import produce from 'immer';
import moment from 'moment';

const INITIAL_STATE = {
	loading: false,
	params: {
		dropInDifferentCity: false,
		dropCity: null,
		pickupLocation: null,
		pickupDate: moment().toDate(),
		dropDate: moment().add(3, 'days').toDate(),
	},
	items: [],
	hasMore: true,
	meta: {
		economy: 0,
		luxury: 0,
		offset: 0,
		pickup: 0,
		sedan: 0,
		sport: 0,
		suv: 0
	},
	isError: false,
	error: {}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ------------ Authenticate user ------------
			case types.SEARCH_CARS_FETCH_DATA_LOADING:
				draft.loading = true;
				draft.params = action.payload;
				draft.items = [];
				draft.meta = INITIAL_STATE.meta;
				draft.isError = false;
				draft.error = {};
				return;

			case types.SEARCH_CARS_FETCH_DATA_SUCCESS:
				draft.loading = false;
				draft.items = action.payload.data;
				draft.hasMore = action.payload.data.length > 0;
				draft.meta = action.payload.meta;
				draft.isError = false;
				draft.error = {};
				return;

			case types.SEARCH_CARS_FETCH_DATA_ERROR:
				draft.loading = false;
				draft.isError = true;
				draft.error = action.payload;
				return;

			case types.SEARCH_MORE_CARS_FETCH_DATA_LOADING:
				draft.loading = true;
				draft.isError = false;
				draft.error = {};
				return;

			case types.SEARCH_MORE_CARS_FETCH_DATA_SUCCESS:
				draft.loading = false;
				const copy = state.items.slice();
				copy.push(...action.payload.data);
				draft.items = copy;
				draft.hasMore = action.payload.data.length > 0;
				draft.meta = action.payload.meta;
				draft.isError = false;
				draft.error = {};
				return;

			case types.SEARCH_MORE_CARS_FETCH_DATA_ERROR:
				draft.loading = false;
				draft.isError = true;
				draft.error = action.payload;
				return;

			default:
				return state;
		}
	});
